import { render, staticRenderFns } from "./web-to-lead-form.vue?vue&type=template&id=4aa4c0aa"
import script from "./web-to-lead-form.vue?vue&type=script&lang=js"
export * from "./web-to-lead-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports